import { ENDLESS_FIXED } from '@/constants';
var afterGeneratePage = function (page) {
    page.resizeType = ENDLESS_FIXED;
    return page;
};
export default {
    afterGeneratePage: afterGeneratePage
};
